import { useAuth0 } from "@auth0/auth0-react";
import { IconButton, TableContainer } from "@material-ui/core";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import Card from "@mui/material/Card";
import Dialog from "@mui/material/Dialog";
import { ReactComponent as CreateCampaignIcon } from "assets/icons/CreateCampaignIcon.svg";
import { ReactComponent as PlusIcon } from 'assets/icons/plus.svg';
import { ReactComponent as SortIcon } from "assets/icons/SortIcon.svg";
import Action from "components/ActionPopOver";
import Button from "components/button/Button";
import { CheckBox } from "components/CheckBox/CheckBox";
import AlertDialog from "components/Dialog";
import Loader from "components/loader/Loader";
import MyButton from "components/MyButton";
import NewDialog from "components/NewDialog/Dialog";
import SearchComp from "components/Searchcomponent";
import { formatDate } from "helper/dateFormat";
import CommunicationService from "Lib/API/Communication";
import AddNewTag from "pages/Members/MemberDetails/AddNewTag";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toastr } from "react-redux-toastr";
import { useHistory } from "react-router-dom";
import {
  setCampaignEditData,
  setCardContent,
  setCreateCampaignDialog,
  setSelectedAudienceRows,
  setSelectedTemplate,
} from "services/api/communication";
import CreateNewCommunicationFilter from "./NewFilter/index";
import {
  ButtonsWrapper,
  Content,
  ContentDialogWrapper,
  DescriptionColumn,
  SearchWrapper,
} from "./Theme";
import { fontConfig } from "theme/fontConfig";

export const AudienceTable = ({
  audienceList,
  page,
  setPage,
  loading,
  searchValue,
  handleInputChange,
  count,
  handleSort,
  refresh,
  setRefresh,
  setToggle,
}) => {
  const headerTitles = [
    { title: "NAME", sortName: "name" },
    { title: "DESCRIPTION", sortName: "" },
    { title: "EMAIL COUNT", sortName: "numberOfEmails" },
    { title: "MOBILE COUNT", sortName: "numberOfPhones" },
    { title: "LAST USED", sortName: "lastUsed" },
    { title: "", sortName: "", className: "sticky-header-column"}
  ];
  const [check, setCheck] = useState([]);
  const [checkAll, setCheckAll] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [deleteAudinceId, setDeleteAudinceId] = useState(null);
  const [confirmDialog, setConfirmDialog] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const { push } = useHistory();
  const [isOpenMergePopUp, setIsOpenMergePopUp] = useState(false);
  const [audienceRow, setAudienceRow] = useState(null);
  const [importOpen, setImportOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importTags, setImportTags] = useState([]);
  const [tagOpen, setTagOpen] = useState(false);
  const [importing, setImporting] = useState(false);
  const [confirmClose, setConfirmClose] = useState(false);
  const dispatch = useDispatch();
  const { createCampainOpenDialog } = useSelector(
    (state) => state.communication
  );
  const TableCellHead = withStyles((theme) => ({
    root: {
      height: "39px",
      padding: "0px 20px",
      borderBottom: "none",
      fontFamily: fontConfig.GeneralTableCellHeadFont.family,
    },
  }))(TableCell);
  const TableCellBody = withStyles((theme) => ({
    root: {
      height: "65px",
      padding: "0px 20px",
      fontFamily: fontConfig.GeneralTableCellBodyFont.family,
      fontSize: "14px",
      color: "#4f4f4f",
    },
  }))(TableCell);
  const useStyles = makeStyles({
    card: {
      borderRadius: "0",
      boxShadow: "none !important",
      "&:hover": {
        boxShadow: "0 8px 16px rgba(0, 0, 0, 0.2)",
      },
    },
  });
  const classes = useStyles();

  const onCheckboxAllChange = (e) => {
    const items = audienceList;
    setCheckAll(e.target.checked);
    if (!e.target.checked) {
      setCheck([]);
    } else {
      const allChecked = [...check, ...items].filter(
        (item, index, self) =>
          index === self.findIndex((i) => i._id === item._id)
      );
      setCheck(allChecked);
      setCheck(items);
    }
  };
  const deleteAudince = async (id) => {
    setConfirmLoading(true);
    try {
      const token = await getAccessTokenSilently();
      const result = await CommunicationService.deleteAudience(token, id);
      toastr.success("Success", "Audince Deleted Successfully!");

      setRefresh(!refresh);
    } catch (err) {
      toastr.error("Error", err?.data?.message);
    } finally {
      setConfirmLoading(false);
      setDeleteAudinceId(null);
      setConfirmDialog(false);
    }
  };

  const onCheckboxChange = (e, row) => {
    const { checked } = e.target;
    if (!checked) {
      setCheckAll(false);
      setCheck((prev) => {
        const checkClone = prev.filter((item) => item._id !== row._id);
        return [...checkClone];
      });
      dispatch(
        setSelectedAudienceRows((prev) => {
          const checkClone = prev.filter((item) => item._id !== row._id);
          return [...checkClone];
        })
      );
      return;
    } else if (check.length === audienceList.length) {
      setCheckAll(true);
    }
    setCheck((prev) => [...prev, row]);
  };
  useEffect(() => {
    dispatch(setSelectedAudienceRows(check));
  }, [check]);

  const closeModal = () => {
    setConfirmClose(true);
  }
  const closeImport = () => {
    setImportOpen(false);
    setImportFile(null);
    setImportTags([]);
    setTagOpen(false);
  };
  const addImportTag = (tag) => {
    setImportTags((prev) =>
      prev.some((item) => item.toLowerCase() === tag.toLowerCase())
        ? prev
        : [...prev, tag]
    );
  };
  const removeImportTag = (tag) => {
    setImportTags((prev) =>
      prev.filter((item) => item.toLowerCase() !== tag.toLowerCase())
    );
  };
  const uploadNewsletter = async () => {
    if (!importFile) {
      toastr.info("Validation", "Please choose a CSV file");
      return;
    }
    if (!importTags.length) {
      toastr.info("Validation", "Please choose a contact tag");
      return;
    }
    setImporting(true);
    try {
      const token = await getAccessTokenSilently();
      const formData = new FormData();
      formData.append("file", importFile);
      formData.append("tags", JSON.stringify(importTags));
      await CommunicationService.importNewsletterList(formData, token);
      toastr.success(
        "Import started",
        "You will get an email when it finishes."
      );
      closeImport();
    } catch (err) {
      toastr.error("Error", err?.data?.message || "Upload failed");
    } finally {
      setImporting(false);
    }
  };
  const confirmCloseHandler = () => {
    setConfirmClose(false);
    setIsOpenMergePopUp(false);
  }


  return (
    <Card className={classes.card}>
      <Content>
        <SearchWrapper>
          <span className="finance-filter-serach-bar ml-5">
            <SearchComp
              value={searchValue}
              setSearchText={handleInputChange}
              placeholder="Search"
              style={{ width: "20.5rem", backgroundColor: "#fff" }}
            />
          </span>
        </SearchWrapper>
        <ButtonsWrapper>
          <Button
            variant="primary-outline"
            size="md"
            style={{
              marginRight: "1rem",
            }}
            onClick={() => setImportOpen(true)}
          >
            <span>Import Newsletter List</span>
          </Button>
          <Button
            variant="secondary-light"
            size="md"
            style={{
              marginRight: "1rem",
            }}
            onClick={() => {
              setAudienceRow(null);
              setIsOpenMergePopUp(true);
              localStorage.setItem("goToCommunication", "audience-info");
            }}
          >
            <PlusIcon fill="#2555EF"/>
            <span>New Audience</span>
          </Button>
          {check?.length > 0 && (
              <Button
                variant="primary"
                size="md"
                onClick={() => {
                  dispatch(setSelectedAudienceRows(check));
                  dispatch(setCreateCampaignDialog(true));
                  dispatch(setCardContent(""));
                  dispatch(setCampaignEditData({}));
                  dispatch(setSelectedTemplate({}));
                }}
              >
                <CreateCampaignIcon />
                <span>Create Campaign</span>
              </Button>
          )}
        </ButtonsWrapper>
      </Content>

      <>
        <div
          style={{ paddingLeft: "17px", paddingRight: "17px", marginTop: 20 }}
        >
          <TableContainer className="scroll-table"> 
            <Table aria-label="collapsible table">
              <TableHead className="charges-table sticky-table-header">
                <TableRow>
                  <TableCellHead className="main-width-class">
                    <CheckBox
                      onChange={(e) => {
                        onCheckboxAllChange(e);
                      }}
                      text={""}
                      style={{ paddingTop: 8, paddingLeft: 5 }}
                      checked={checkAll}
                    />
                  </TableCellHead>
                  {headerTitles.map((item) => (
                    <TableCellHead
                      className={`class__header__cell className_head ${item.className}`}
                      key={item}
                    >
                      <div>
                        {item?.title}
                        {item?.sortName && (
                          <IconButton>
                            <SortIcon
                              onClick={() => handleSort(item?.sortName)}
                            />
                          </IconButton>
                        )}
                      </div>
                    </TableCellHead>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody
                style={{
                  backgroundColor: "white",
                }}
              >
                {loading ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <div className="user__loader" style={{ height: "320px" }}>
                        <Loader />
                      </div>
                    </TableCell>
                  </TableRow>
                ) : audienceList?.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={10} align="center">
                      <h6 style={{ height: "320px", marginTop: "100px" }}>
                        No Audience Found
                      </h6>
                    </TableCell>
                  </TableRow>
                ) : (
                  audienceList?.map((row, index) => (
                    <React.Fragment key={index}>
                      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                        <TableCellBody
                          className="main-width-class"
                          align="left"
                        >
                          <CheckBox
                            onChange={(e) => onCheckboxChange(e, row)}
                            checked={check.some((obj) => obj._id === row?._id)}
                            text={""}
                          />
                        </TableCellBody>
                        <TableCellBody
                          className="status-head main-width-class"
                          component="th"
                          scope="row"
                          onClick={() => {}}
                        >
                          {row?.name}
                        </TableCellBody>
                        <TableCellBody
                          className="main-width-class"
                          align="left"
                          onClick={() => {}}
                        >
                          <DescriptionColumn>
                            {/* <p className="school-table-year"> */}
                            {row?.description}
                            {/* </p> */}
                          </DescriptionColumn>
                        </TableCellBody>

                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                          onClick={() => {}}
                        >
                          {row?.numberOfEmails}
                        </TableCellBody>
                        <TableCellBody
                          style={{
                            wordBreak: "break-all",
                            whiteSpace: "normal",
                          }}
                          className="paid-head main-width-class"
                          align="left"
                          onClick={() => {}}
                        >
                          {row?.numberOfPhones}
                        </TableCellBody>
                        <TableCellBody
                          className="transaction-head main-width-class"
                          align="left"
                          onClick={() => {}}
                        >
                          {row?.lastUsed && formatDate({date:row?.lastUsed, formatType: "defaultWithUTC"})}
                        </TableCellBody>
                        <TableCellBody
                          className="exp-action-head main-width-class sticky-body-column"
                          align="right"
                        >
                          <div
                            style={{ cursor: "pointer", paddingleft: "0px" }}
                          >
                            <Action
                              action="communication"
                              style={{ width: "16px" }}
                              onEditClick={() => {
                                setAudienceRow({
                                  id: row?._id,
                                  name: row?.name,
                                  description: row?.description,
                                  filter: row?.filter,
                                });
                                setIsOpenMergePopUp(!isOpenMergePopUp);
                              }}
                              onCreateCampaignClick={() => {
                                dispatch(setCreateCampaignDialog(true));
                                dispatch(setCampaignEditData({}));
                                dispatch(setSelectedAudienceRows([row]));
                              }}
                              onDeleteClick={() => {
                                setDeleteAudinceId(row?._id);
                                setConfirmDialog(true);
                              }}
                            />
                          </div>
                        </TableCellBody>
                      </TableRow>
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
        <div className="pagination-custom mt-9">
          <Pagination
            count={Math.ceil(count / 30)}
            color="primary"
            variant="outlined"
            page={page + 1}
            onChange={(event, value) => {
              setPage(value - 1);
            }}
          />
        </div>
      </>
      <AlertDialog
        open={confirmDialog}
        onDecline={() => {
          setDeleteAudinceId(null);
          setConfirmDialog(false);
        }}
        onAccept={() => {
          console.log("deleteAudinceId", deleteAudinceId);
          if (deleteAudinceId) {
            deleteAudince(deleteAudinceId);
          }
        }}
        title={"Are you sure?"}
        description={"Do you want to delete this audience?"}
        disabled={confirmLoading}
      />
      <NewDialog
        isOpen={isOpenMergePopUp}
        // message={message}
        handleClose={closeModal}
        // loading={loadingMerge}
        title={audienceRow ? "Edit Audience" : "Create New Audience"}
        sx={{
          "& .MuiDialog-paperWidthSm": {
            minWidth: "997.01px",
            height: "97%",
            overflow: "hidden",
          },
        }}
        content={
          <ContentDialogWrapper>
            <CreateNewCommunicationFilter
              closeModal={() => {
                setIsOpenMergePopUp(false);
              }}
              setRefresh={setRefresh}
              audienceRow={audienceRow}
            />
          </ContentDialogWrapper>
        }
        contentStyle={{
          display: "flex",
          justifyContent: "center",
          flex: 1,
          minHeight: 0,
          overflow: "hidden",
        }}
        buttonStyle={{ justifyContent: "right" }}
      ></NewDialog>
      <AlertDialog
        open={confirmClose}
        onDecline={() => {
          setConfirmClose(false);
        }}
        onAccept={confirmCloseHandler}
        title={"Are you sure?"}
        description={"Do you want to discard the changes you made?"}
      />
      <NewDialog
        isOpen={importOpen}
        handleClose={closeImport}
        title="Import Newsletter List"
        sx={{
          "& .MuiDialog-paperWidthSm": {
            minWidth: "480px",
          },
        }}
        content={
          <div style={{ padding: "8px 24px 16px", width: "100%" }}>
            <input
              type="file"
              accept=".csv,text/csv"
              onChange={(e) => setImportFile(e.target.files?.[0] || null)}
            />
            <div style={{ marginTop: 16 }}>
              <a href="/newsletterListTemplate.csv" download>
                click to download example CSV
              </a>
            </div>
            <div style={{ marginTop: 16 }}>
              <div style={{ fontWeight: 500, marginBottom: 8 }}>Contact tag</div>
              <div style={{ display: "flex", flexWrap: "wrap", gap: 8, alignItems: "center" }}>
                {importTags.map((tag) => (
                  <span key={tag}>
                    {tag}
                    <span
                      onClick={() => removeImportTag(tag)}
                      style={{ marginLeft: 6, cursor: "pointer" }}
                    >
                      x
                    </span>
                  </span>
                ))}
                <span
                  onClick={() => setTagOpen(true)}
                  style={{ cursor: "pointer", color: "#2555EF" }}
                >
                  + Add a tag
                </span>
              </div>
            </div>
          </div>
        }
        buttonStyle={{ justifyContent: "flex-end", gap: 12, padding: "0 24px 24px" }}
      >
        <Button
          variant="primary-outline"
          size="md"
          onClick={closeImport}
          disabled={importing}
          style={{ marginRight: "1rem" }}
        >
          <span>Cancel</span>
        </Button>
        <Button
          variant="primary"
          size="md"
          onClick={uploadNewsletter}
          disabled={importing}
        >
          <span>{importing ? "Uploading" : "Upload"}</span>
        </Button>
      </NewDialog>
      <Dialog
        open={tagOpen}
        onClose={() => setTagOpen(false)}
        PaperProps={{
          style: {
            border: "1px solid #000000",
            background: "#f5f5f5",
          },
        }}
      >
        <AddNewTag
          setOpenTag={setTagOpen}
          openTag={tagOpen}
          addTagHandler={addImportTag}
          deleteTagHandler={removeImportTag}
          selectedUserTag={importTags}
          type="contact"
        />
      </Dialog>
    </Card>
  );
};
